import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import PropTypes from 'prop-types';
import queryString from 'query-string';

import AddBookedTransactionDialog from '../../components/AddBookedTransactionDialog';
import CardBase from '../../components/CardBase';
import ReconcileAccountDialog from '../../components/ReconcileAccountDialog';
import history from '../../history';

class LoanAccountQuickLinksCard extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      addBookedTransactionDialog: false,
      reconcileAccountDialog: false,
    };
  }

  setTransactionsStale = () => {
    const { markStale } = this.props;
    markStale('accountGraph');
    markStale('journals');
  };

  componentDidMount() {
    const { location, openAddTransactionFromQuery } = this.props;
    const parsedQuery = queryString.parse(location.search);
    if (parsedQuery.addTransaction || openAddTransactionFromQuery) {
      this.setState({
        addBookedTransactionDialog: true,
      });
    }
  }

  closeAddBookedTransactionDialog = () => {
    const { location } = this.props;
    const parsedQuery = queryString.parse(location.search);
    if (parsedQuery.addTransaction) {
      delete parsedQuery.addTransaction;
      const query = queryString.stringify(parsedQuery);
      history.replace(`${location.pathname}${query ? `?${query}` : ''}`);
    }
    this.setState({
      addBookedTransactionDialog: false,
    });
  };

  render() {
    const { addBookedTransactionDialog, reconcileAccountDialog } = this.state;

    const { accountId, mortgageEscrowAccountId } = this.props;

    return (
      <>
        <AddBookedTransactionDialog
          isOpen={addBookedTransactionDialog}
          closeDialog={this.closeAddBookedTransactionDialog}
          onAddTransaction={this.setTransactionsStale}
        />
        {reconcileAccountDialog && (
          <ReconcileAccountDialog
            isOpen
            closeDialog={() =>
              this.setState({
                reconcileAccountDialog: false,
              })
            }
            onReconcile={this.setTransactionsStale}
            accountId={accountId}
          />
        )}
        <Grid item xs={12} sm={6} md={6} lg={4}>
          <CardBase>
            <Box display="flex" flexDirection="column" height={1} px={2} pt={2} pb={3}>
              <Typography variant="h6" gutterBottom>
                Quicklinks
              </Typography>
              <Box marginBottom={1}>
                <Button
                  color="secondary"
                  variant="outlined"
                  size="large"
                  fullWidth
                  onClick={() =>
                    this.setState({
                      addBookedTransactionDialog: true,
                    })
                  }
                >
                  Add Transaction
                </Button>
              </Box>
              <Box marginBottom={1}>
                <Button
                  color="secondary"
                  variant="outlined"
                  size="large"
                  fullWidth
                  onClick={() =>
                    this.setState({
                      reconcileAccountDialog: true,
                    })
                  }
                >
                  Reconcile Account
                </Button>
              </Box>
              <Box marginBottom={1}>
                <Button
                  color="secondary"
                  variant="outlined"
                  size="large"
                  fullWidth
                  component={RouterLink}
                  to={`/transactions/booked?accountId=${accountId}`}
                >
                  Expanded Transactions
                </Button>
              </Box>
              {mortgageEscrowAccountId && (
                <Box marginBottom={1}>
                  <Button
                    color="secondary"
                    variant="outlined"
                    size="large"
                    fullWidth
                    component={RouterLink}
                    to={`/accounts/loans/escrow/${mortgageEscrowAccountId}`}
                  >
                    View Escrow Account
                  </Button>
                </Box>
              )}
            </Box>
          </CardBase>
        </Grid>
      </>
    );
  }
}

LoanAccountQuickLinksCard.defaultProps = {};

LoanAccountQuickLinksCard.propTypes = {
  markStale: PropTypes.func.isRequired,
  accountId: PropTypes.node.isRequired,
  mortgageEscrowAccountId: PropTypes.node.isRequired,
  openAddTransactionFromQuery: PropTypes.bool.isRequired,
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
    search: PropTypes.string.isRequired,
  }).isRequired,
};

export default LoanAccountQuickLinksCard;
